import { SetStateAction } from "react";
import { SectionRequest } from "../../redux/api/section/types";
import { Container, Header, SpaceBetween, Table } from "@cloudscape-design/components";
import IncredableButton from "../../components/button";
import { Col, Divider, Row, Space, Typography } from "antd";

interface StepFourProps {
    section: SectionRequest | undefined;
    setCurrent: (value: SetStateAction<number>) => void;
}
const StepFour: React.FC<StepFourProps> = ({ section, setCurrent }) => {
    const handleEdit = (stepIndex: number) => {
        setCurrent(stepIndex);
    };
    const sectionDetails = [
        {
            label: "Section Name",
            value: (
                <Space>
                    {section?.name}
                </Space>
            ),
        },
        {
            label: "Description",
            value: (
                <Space>
                    {(section?.description)}
                </Space>
            ),
        },
    ];
    return (
        <div style={{ marginTop: "30px" }}>
            <SpaceBetween size={"l"} direction="vertical">
                <Container
                    header={
                        <div>
                            <Header
                                variant="h3"
                                actions={
                                    <IncredableButton secondary onClick={() => handleEdit(0)}>
                                        Edit
                                    </IncredableButton>
                                }
                            >
                                 Type Details
                            </Header>
                            <Divider style={{ marginTop: "120x" }} />
                        </div>
                    }
                >
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col span={16}>
                            <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                                Section Type
                            </div>
                            <div>{section?.isFacility === false ? "Provider" : "Facility"}</div>
                        </Col>
                    </Row>
                </Container>
                <Container
                    header={
                        <div>
                            <Header
                                variant="h3"
                                actions={
                                    <IncredableButton secondary onClick={() => handleEdit(1)}>
                                        Edit
                                    </IncredableButton>
                                }
                            >
                                Section Details
                            </Header>
                            <Divider style={{ marginTop: "12px" }} />
                        </div>
                    }
                >
                    <Row gutter={[16, 16]}>
                        {sectionDetails.map((section, index) => (
                            <Col span={12} key={index}>
                                <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                                    {section.label}
                                </div>
                                <div>{section.value}</div>
                            </Col>
                        ))}
                    </Row>
                </Container>

                <Table
                    items={!!section ? section?.attributes : []}
                    columnDefinitions={[
                        {
                            id: "name",
                            header: <Typography.Text>Name</Typography.Text>,
                            cell: (item) => (
                                <Typography.Text>{item.name || "-"}</Typography.Text>
                            ),
                        },
                        {
                            id: "Type",
                            header: <Typography.Text>Type</Typography.Text>,
                            cell: (item) => (
                                <Typography.Text>
                                    {(item?.type)}
                                </Typography.Text>
                            ),
                        },
                        {
                            id: "Description",
                            header: <Typography.Text>Description</Typography.Text>,
                            cell: (item) => (
                                <Typography.Text>
                                    {(item?.description)||"-"}
                                </Typography.Text>
                            ),
                        },
                    ]}
                    header={
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span style={{ fontWeight: "600", fontSize: "18px" }}>Add FlexFields to Section</span>
                            <IncredableButton secondary onClick={() => handleEdit(2)}>
                                Edit
                            </IncredableButton>
                        </div>
                    }
                />
            </SpaceBetween>
        </div>
    );
};

export default StepFour;